import styled, { StyledProp } from '@/styled';

interface ICarouselProps {
  goTo: () => void;
}

const CarouselPageCustom = ({ className, goTo }: StyledProp & ICarouselProps) => {
  return (
    <div className={className} onClick={goTo}>
      <div className='dot'>
        <div className='dots'>
          <section className='container'>
            <svg height='32' width='32' className='stroker'>
              <circle className='circle' cx='16' cy='16' r='11' fillOpacity='0' />
            </svg>
            <svg height='24' width='24' className='toFillIN'>
              <circle cx='12' cy='12' r='7' />
            </svg>
          </section>
        </div>
      </div>
    </div>
  );
};

export default styled(CarouselPageCustom)`
  z-index: 1;
  .dots {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    display: flex;
  }

  .stroker > circle {
    stroke-width: 1;
    stroke: ${({ theme }) => theme.colorPrimary};
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
  }

  .toFillIN {
    transform: translate(16%, 16%);
    position: absolute;
  }

  .toFillIN > circle {
    cursor: pointer;
    stroke-width: 1;
    fill-opacity: 0;
    stroke: ${({ theme }) => theme.palette.alpha(theme.palette.gray[6], 0.5)};
  }

  .slick-active > & > .dot > .dots > .container > .stroker > circle {
    animation: stroke 190s ease-out forwards;
  }

  .slick-active > & > .dot > .dots > .container > .toFillIN > circle {
    fill-opacity: 1;
    stroke-width: 0;
    fill: ${({ theme }) => theme.colorPrimary};
  }

  @keyframes stroke {
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;
